import styles from './TourSidebar.module.css';
import Header from './../common/header/Header';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { Link, useRouteMatch, useHistory } from "react-router-dom";
import { useAppStore } from './../../hooks/store/useAppStore';
import { tourScenesSelector, tourErrorInfoSelector, tourPrivacySelector } from './../../hooks/store/getters';
import { 
    setTourNewSceneAndActiveSceneIndexSelector,
    setTourActiveSceneIndexSelector, resetTourSelector, setTourPrivacySelector
} from './../../hooks/store/setters';
import { useEffect, useState } from "react";
import { setTourNewSceneErrorSelector } from './../../hooks/store/setters';
import { setNotificationMessageSelector } from './../../hooks/store/setters';
import { resetTourErrorSelector } from './../../hooks/store/setters';
import { setTourErrorInfoSelector } from './../../hooks/store/setters';
import { FormError } from '../common/input/Input';
import { MdMenu, MdClose } from "react-icons/md";
import { setConfirmModelSelector } from './../../hooks/store/setters';
import { TOUR_PRIVACY } from '../../constants/TourPrivacy.const';
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from 'react-bootstrap/ToggleButton';

const MAX_SCENES_PER_TOUR = 100;

const TourSidebar = ({ handleTourSubmit, pageTitle }) => {
    
    const { url } = useRouteMatch();
    const history = useHistory();
    
    const tourScenes = useAppStore(tourScenesSelector);
    const setTourNewScene = useAppStore(setTourNewSceneAndActiveSceneIndexSelector);
    const setTourActiveSceneIndex = useAppStore(setTourActiveSceneIndexSelector);
    const tourActiveSceneIndex = useAppStore(state => state.tourActiveSceneIndex);
    const resetTour = useAppStore(resetTourSelector);
    const setTourNewSceneError = useAppStore(setTourNewSceneErrorSelector);
    const setNotificaitonMessage = useAppStore(setNotificationMessageSelector);
    const resetTourError = useAppStore(resetTourErrorSelector);
    const setTourErrorInfo = useAppStore(setTourErrorInfoSelector);
    const tourError = useAppStore(tourErrorInfoSelector);
    const [showSidebar, setShowSidebar] = useState(false);
    const setConfirmModel = useAppStore(setConfirmModelSelector);
    const setTourPrivacy = useAppStore(setTourPrivacySelector);
    const tourPrivacy = useAppStore(tourPrivacySelector);
    
    useEffect(() => {
        return () => {
          resetTour();
          setTourActiveSceneIndex(null);
        }; 
        // eslint-disable-next-line   
    }, []);

    useEffect(() => {
        window.addEventListener("beforeunload", handleBeforeUnload);
        window.addEventListener("unload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            window.removeEventListener("unload", handleBeforeUnload);
        };
    }, []);
      
    const handleBeforeUnload = (e) => {
        console.log('in relaod fun');
        e.preventDefault();
        const message =
            "Are you sure you want to leave? All provided data will be lost.";
        e.returnValue = message;
        return message; 
    };
    
    const addNewScene = () => {
        setTourNewScene();
        setTourNewSceneError();
        setTourErrorInfo({ scene: "" });
        setShowSidebar(false)
        history.push(`${url}/create-scene`);
    }
    const handleCancel = () => {
        setConfirmModel(
            { show: true, 
              title: "Cancel Tour",
              text: "are you sure want to cancel",
              successButtonText: "Yes",
              cancelButtonText: "No",
              successCallback: cancelTour,
            }
          );
    }

    const cancelTour = () => {
        setNotificaitonMessage("");
        setConfirmModel({ show: false });
        resetTourError();
        history.push('/');
    }
    
    
    const setActiveScene = sceneIndex => {
        setShowSidebar(false)
        setTourActiveSceneIndex(sceneIndex)
    }
    
    const toggleSidebar = () => {
        setShowSidebar(!showSidebar)
    }
    
    const updatePrivacy = (value) => {
        console.log('updatePrivacy' , value)
        setTourPrivacy(value)
    }

    return (
        <>
            <div className={styles.menu} onClick={toggleSidebar}>
                {
                    showSidebar ? <MdClose /> : <MdMenu />
                }
            </div>
            { showSidebar && <div className={styles.menuBackdrop}></div> }
                    
            <section 
                className={`${styles.tourSideBar} ${showSidebar ? styles.tourSideBarExpanded : ''}`}
            >
                <Header vertical={true} />
                
                <Container>
                    <div className={styles.tourSiderbarMenu}>
                        <div className={styles.tourBlock}>
                            <h4>{ pageTitle }</h4>
                            <Button as={Link} 
                                block variant="danger" 
                                to={`${url}/tour-info`}
                            >
                                Tour Info
                            </Button>
                            {
                                tourScenes.length < MAX_SCENES_PER_TOUR && <Button  
                                    block variant="warning"
                                    // to={`${url}/create-scene`}
                                    onClick={addNewScene}
                                >
                                    Create Scene
                                </Button>
                            }
                        </div>

                        <div className={styles.createdScenesBlock}>
                            <h6>Scenes</h6>
                            {
                                !tourScenes.length && <Button block disabled 
                                    variant="outline-info" className={styles.noScenes}>
                                    No Scenes Created
                                </Button>
                            }
                            
                            <FormError error={tourError.scene} />
                            
                            {
                                tourScenes.map((scene, idx) => {
                                    return (
                                        <Button key={idx} block
                                            variant={`${tourActiveSceneIndex===idx ? 'info' : 'outline-info'}`}
                                            as={Link}
                                            to={`${url}/create-scene`}
                                            onClick={() => setActiveScene(idx)}
                                        >{ scene.name || `Scene ${idx+1}` }</Button>
                                    )
                                })
                            }
                        </div>
                    </div>
                </Container>
                <Container>
                    <div className={styles.privacySettings}>
                        <h6>Privacy Setting</h6>
                        <ButtonGroup toggle >
                            <ToggleButton
                                type="radio"
                                variant="outline-info"
                                name="privacy"
                                value={TOUR_PRIVACY.PUBLIC}
                                checked={tourPrivacy === TOUR_PRIVACY.PUBLIC}
                                onChange={(e) => updatePrivacy(TOUR_PRIVACY.PUBLIC)}
                            >Public</ToggleButton>
                            <ToggleButton
                                type="radio"
                                variant="outline-info"
                                name="privacy"
                                value={TOUR_PRIVACY.PRIVATE}
                                checked={tourPrivacy === TOUR_PRIVACY.PRIVATE}
                                onChange={(e) => updatePrivacy(TOUR_PRIVACY.PRIVATE)}
                            >Private</ToggleButton>
                            <ToggleButton
                                type="radio"
                                variant="outline-info"
                                name="privacy"
                                value={TOUR_PRIVACY.UNLISTED}
                                checked={tourPrivacy === TOUR_PRIVACY.UNLISTED}
                                onChange={(e) => updatePrivacy(TOUR_PRIVACY.UNLISTED)}
                            >Unlisted</ToggleButton>
                        </ButtonGroup>
                        </div>
                </Container>
                <Container className="mt-4">
                    <div className={styles.sidebarFooter}>
                        <Button block variant="light" onClick={handleTourSubmit}>Submit</Button>
                        {/* <Link to="/" className="d-block mt-2"> */}
                            <Button block variant="outline-light" onClick={handleCancel}>Cancel</Button>
                        {/* </Link> */}
                    </div>
                </Container>
            </section>
        </>
    );
};

export default TourSidebar;